import { event, purchase, set } from "vue-gtag";

const Tracking = {
  trackAddToCart: function(product, quantity, props) {
    let prices = [];
    if (product.price) prices.push(product.price);
    if (product.wholesale_price) prices.push(product.wholesale_price);
    let price = Math.min(...prices);

    event('add_to_cart', {
      items: [
        {
          id: product.id,
          name: product.name,
          sku: product.sku,
          price: price,
          quantity: quantity,
        },
      ],
      user: this.userInfo(props)
    });
  },
  trackRemoveFromCart: function(product, quantity, props) {
    let prices = [];
    if (product.price) prices.push(product.price);
    if (product.wholesale_price) prices.push(product.wholesale_price);
    let price = Math.min(...prices);

    event('remove_from_cart', {
      items: [
        {
          id: product.id,
          name: product.name,
          sku: product.sku,
          price: price,
          quantity: quantity,
        }
      ],
      user: this.userInfo(props)
    });
  },
  trackCartQuantityUpdate: function(product, old_quantity, new_quantity, props) {
    let diff = new_quantity - old_quantity;
    if (diff !== 0) {
      if (diff > 0) {
        this.trackAddToCart(product, diff, props);
      } else {
        this.trackRemoveFromCart(product, Math.abs(diff), props);
      }
    }
  },
  trackPurchase: function(order, items) {
    purchase({
      transaction_id: order.id,
      value: order.subtotal,
      currency: 'USD',
      tax: order.sales_tax_amount,
      shipping: order.shipping_cost,
      items: items.map((item) => {
        return {
          id: item.id,
          name: item.product_name,
          sku: item.product_sku,
          quantity: item.qty,
          price: item.costTotal,
        }
      }),
    });
  },
  setGaInfo: function(props) {
    if (props.auth.user) {
      set(this.userInfo(props))
    }
  }
}

export default Tracking;